{
  "name": "43-1/5-Syntonic Comma MT (dbbb-d###)",
  "description": "43-tone scale in extended 1/5 Syntonic Comma meantone. Each fifth in the range d♭♭♭-d♯♯♯ is narrowed from its JI ratio 2:3 by 1/5 of a Syntonic Comma (80:81 = ca. 21.5c), so that five successive fifths produce a major seventh (15/8). Standard 12-tone meantone usually ranges from E♭ to G♯, leaving a so-called \"wolf\" fifth. By extending the tuning to 43 notes, a circulating well-temperament is produced.",
  "scale": [
    "28.1551",
    "55.4211",
    "83.5762",
    "111.731",
    "139.886",
    "167.152",
    "195.307",
    "223.463",
    "250.729",
    "278.884",
    "307.039",
    "335.194",
    "362.46",
    "390.615",
    "418.77",
    "446.925",
    "474.191",
    "502.346",
    "530.501",
    "557.767",
    "585.922",
    "614.078",
    "642.233",
    "669.499",
    "697.654",
    "725.809",
    "753.075",
    "781.23",
    "809.385",
    "837.54",
    "864.806",
    "892.961",
    "921.116",
    "949.271",
    "976.537",
    "1004.69",
    "1032.85",
    "1060.11",
    "1088.27",
    "1116.42",
    "1144.58",
    "1171.84",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "43-MT-1_5-SC",
  "built_in_group": "Extended Meantone",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "♭♭d",
    "♯♯b",
    "♯c",
    "♭d",
    "♭♭♭e",
    "♯♯c",
    "d",
    "♭♭e",
    "♯♯♯c",
    "♯d",
    "♭e",
    "♭♭f",
    "♯♯d",
    "e",
    "♭f",
    "♯♯♯d",
    "♯e",
    "f",
    "♭♭g",
    "♯♯e",
    "♯f",
    "♭g",
    "♭♭♭a",
    "♯♯f",
    "g",
    "♭♭a",
    "♯♯♯f",
    "♯g",
    "♭a",
    "♭♭♭b",
    "♯♯g",
    "a",
    "♭♭b",
    "♯♯♯g",
    "♯a",
    "♭b",
    "♭♭c",
    "♯♯a",
    "b",
    "♭c",
    "♭♭♭d",
    "♯b"
  ],
  "note_colors": [
    "#ffdbdb",
    "#ffe5e5",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#e4fbe6",
    "#dee2da",
    "#ffffff",
    "#ffe5e5",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#cee3e2",
    "#dee2da"
  ],
  "equivSteps": 43,
  "fundamental": 440,
  "reference_degree": 32,
  "center_degree": 0,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751
}
